"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _fsm = require("@xstate/fsm");

var _constants = require("../constants");

var _state = require("./state");

var _constants2 = require("./constants");

var _notificationManual = _interopRequireDefault(require("./notification-manual"));

var _notificationFinish = _interopRequireDefault(require("./notification-finish"));

var _notificationComplete = _interopRequireDefault(require("./notification-complete"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IntegrationGuideNotification = /*#__PURE__*/function (_PureComponent) {
  _inherits(IntegrationGuideNotification, _PureComponent);

  var _super = _createSuper(IntegrationGuideNotification);

  function IntegrationGuideNotification(props) {
    var _this;

    _classCallCheck(this, IntegrationGuideNotification);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "service", void 0);

    _defineProperty(_assertThisInitialized(_this), "getContext", function () {
      var steps = _this.props.steps;
      return {
        activeStep: steps[0],
        nextStep: steps[1]
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onNextStepClick", function () {
      var onNextStepClick = _this.props.onNextStepClick;
      var stateMachineContext = _this.state.stateMachineContext;
      stateMachineContext.nextStep && onNextStepClick(stateMachineContext.nextStep);
    });

    _defineProperty(_assertThisInitialized(_this), "markAsComplete", function () {
      var onManualCompleteClick = _this.props.onManualCompleteClick;
      var stateMachineContext = _this.state.stateMachineContext;

      if (onManualCompleteClick && stateMachineContext.activeStep) {
        onManualCompleteClick(stateMachineContext.activeStep);
      }

      _this.service.send({
        type: 'NEXT'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getElement", function (type) {
      var _this$props = _this.props,
          onFinishClick = _this$props.onFinishClick,
          className = _this$props.className;
      var stateMachineContext = _this.state.stateMachineContext;
      var activeStep = stateMachineContext === null || stateMachineContext === void 0 ? void 0 : stateMachineContext.activeStep;
      var nextStep = stateMachineContext === null || stateMachineContext === void 0 ? void 0 : stateMachineContext.nextStep;
      var typesMap = new Map([[_constants2.STATUS_MANUAL, /*#__PURE__*/_jsx(_notificationManual["default"], {
        className: className,
        markAsComplete: _this.markAsComplete
      })], [_constants2.STATUS_FINISH_INTEGRATION, /*#__PURE__*/_jsx(_notificationFinish["default"], {
        className: className,
        onFinishClick: onFinishClick,
        activeStep: activeStep
      })], [_constants2.STATUS_CONTINUE_INTEGRATION, /*#__PURE__*/_jsx(_notificationComplete["default"], {
        className: className,
        nextStep: nextStep,
        activeStep: activeStep,
        onNextStepClick: _this.onNextStepClick
      })]]);
      return typesMap.get(type) || null;
    });

    var notificationMachine = (0, _state.createNotificationMachine)(_this.getContext());
    _this.service = (0, _fsm.interpret)(notificationMachine);
    _this.state = {
      stateMachineValue: notificationMachine.initialState.value,
      stateMachineContext: notificationMachine.initialState
    };
    return _this;
  }

  _createClass(IntegrationGuideNotification, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this,
          _steps$;

      this.service.subscribe(function (state) {
        _this2.setState({
          stateMachineValue: state.value,
          stateMachineContext: state.context
        });
      });
      this.service.start();
      var steps = this.props.steps;
      var context = this.getContext();

      if (steps && ((_steps$ = steps[0]) === null || _steps$ === void 0 ? void 0 : _steps$.type) === _constants.INTEGRATION_GUIDE_STEP.MANUAL) {
        this.service.send({
          type: 'NEXT',
          context: context
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _prevProps$steps$, _steps$2;

      var steps = this.props.steps;
      var context = this.getContext();

      if ((prevProps === null || prevProps === void 0 ? void 0 : (_prevProps$steps$ = prevProps.steps[0]) === null || _prevProps$steps$ === void 0 ? void 0 : _prevProps$steps$.id) !== ((_steps$2 = steps[0]) === null || _steps$2 === void 0 ? void 0 : _steps$2.id)) {
        this.service.send({
          type: 'RESET',
          context: context
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.service.stop();
    }
  }, {
    key: "render",
    value: function render() {
      var stateMachineValue = this.state.stateMachineValue;

      if (stateMachineValue === _constants2.STATUS_DEFAULT) {
        return null;
      }

      return this.getElement(stateMachineValue);
    }
  }]);

  return IntegrationGuideNotification;
}(_react.PureComponent);

var _default = IntegrationGuideNotification;
exports["default"] = _default;